export function isSX({ code }) {
    return code.includes('SX');
}
export function isControlDevice(device_type) {
    if (!device_type) {
        return false;
    }
    return isSX(device_type) || device_type.code.includes('ZTA');
}
export function isClimatic(type_or_name) {
    if (!type_or_name) {
        return false;
    }
    if (typeof type_or_name === 'string') {
        return type_or_name.startsWith('CLIMATIC');
    }
    const { code } = type_or_name;
    return code.startsWith('CLIMATIC');
}
export function isClimaticPro(type_or_name) {
    if (!type_or_name) {
        return false;
    }
    if (typeof type_or_name === 'string') {
        return type_or_name.startsWith('CLIMATIC_PRO');
    }
    const { code } = type_or_name;
    return code.startsWith('CLIMATIC_PRO');
}
export function isVehicleDevice(device_type) {
    if (!device_type) {
        return false;
    }
    const { code } = device_type;
    return code.includes('ZTC') || code.includes('ZTA');
}
export function isOnlyGuardDevice(device_type) {
    return device_type.code.includes('C2000');
}
export function isLegacyHeatingDevice(device_type) {
    return (device_type.code.includes('T10') ||
        device_type.code.includes('L1') ||
        device_type.code === 'H1000' ||
        device_type.code === 'H2000');
}
export function isLegacyDevice(device_type) {
    if (!device_type) {
        return false;
    }
    return (isLegacyHeatingDevice(device_type) ||
        isControlDevice(device_type) ||
        isSX(device_type) ||
        isVehicleDevice(device_type));
}
